module.exports = __webpack_public_path__ + "media/images/landing-pages/annie-cce7ce91a6226fcad52e66329ef45a0f.png";